module.exports = __webpack_public_path__ + "d7a0df991f3fd34b25c240d712b002eb.ttf";